import auth from '../../services/auth'
import MessageDialog from '../../components/message-dialog.vue'
import { phone } from '../../filters/string'

export default {

  data() {
    return {
      password: undefined,
      oldPassword: undefined,
      passwordRepeat: undefined,
      errorMessage: undefined,
      loading: undefined,

      password: null,
      passwordLength: 0,
		  containsEightCharacters: false,
      containsNumber: false,
      containsUppercase: false,
		  containsSpecialCharacter: false,
      validPassword: false,
      email: undefined,
      newEmail: undefined,
      newPhone: undefined,
      dddCellphone: undefined,
      nroCellphone: undefined,
      oldDddCellphone: undefined,
      oldNroCellphone: undefined,
    }
  },

  computed: {
    type() {
      return this.$route.params.type;
    },
    newCellPhone: {
      get() {
        return this.getCelFormated();
      },
      set(newValue) {
        this.setCelFormated(newValue);
      }
    },
    oldCellPhone: {
      get() {
        return this.getOldCelFormated();
      },
      set(newValue) {
        this.setOldCelFormated(newValue);
      }
    }

  },

  created(){
    
  },

  methods: {
    getCelFormated(obj) {
      return phone(this.dddCellphone + this.nroCellphone);
    },
    setCelFormated(value) {
      let t = value.replace(/[^0-9]/g, '');
      this.dddCellphone = t.substring(0, 2);
      this.nroCellphone = t.substring(2, 11);
    },
    getOldCelFormated(obj) {
      return phone(this.oldDddCellphone + this.oldNroCellphone);
    },
    setOldCelFormated(value) {
      let t = value.replace(/[^0-9]/g, '');
      this.oldDddCellphone = t.substring(0, 2);
      this.oldNroCellphone = t.substring(2, 11);
    },
    doChange() {
      origin = this.$route.params.type;
      this.$validator.validateAll().then((success) => {
        if (origin == 'UPDATE_PASSWORD') {
          this.loading = auth.changePassword(this.oldPassword, this.password)
          .then((value) => {
            if (value)
            return MessageDialog.show({
              headerClass: 'modal-success',
              title: 'Definição de senha',
              message: 'Sua senha foi alterada com sucesso!',
              type: 'OK'
            }).then(() => {
              this.$router.push({name: 'plans'});
            })
          })
        } else {
          if (origin == 'UPDATE_USER_EMAIL') {
            auth.saveNewEmail(this.newEmail);
            this.errorMessage = undefined;
            this.loading = auth.sendTokenNewUserData(auth.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase(), '', this.newEmail)
              .then((value) => {
                    this.$router.push({name: '2fa-interno', params: {type: 'UPDATE_NEW_USER_EMAIL'}});
                }).catch(err => {
                  this.errorMessage = err.status && err.data.status && err.data.status.message;
                });
          } else {
            if (origin == 'UPDATE_USER_PHONE') {
              auth.saveNewPhone(this.newCellPhone.replace(/[^\d]+/g, ''));
              this.loading = auth.sendTokenNewUserData(auth.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase(), this.newCellPhone.replace(/[^\d]+/g, ''), '')
              .then((value) => {
                this.$router.push({name: '2fa-interno', params: {type: 'UPDATE_NEW_USER_PHONE'}}); 
                }).catch(err => {
                  this.errorMessage = err.status && err.data.status && err.data.status.message;
                });
            }
          }
        }
      }).catch(error => {
        this.errorMessage = error.data && error.data.status && error.data.status.message || "Erro do servidor.";
      });
    },

    checkPassword() {
      this.passwordLength = this.password.length;
			const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
			
      if (this.passwordLength > 8) {
        this.containsEightCharacters = true;
      } else {
        this.containsEightCharacters = false;
			}
			
      this.containsNumber = /\d/.test(this.password);
      this.containsUppercase = /[A-Z]/.test(this.password);
			this.containsSpecialCharacter = format.test(this.password);
      
      if (this.containsEightCharacters === true &&
					this.containsSpecialCharacter === true &&
					this.containsUppercase === true &&
					this.containsNumber === true) {
						this.validPassword = true;			
      } else {
        this.validPassword = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/user-contacts-change.js